module.exports = __webpack_public_path__ + "img/030-north-korea.4c4b2940.svg";